import React, { memo, useCallback, useEffect, useMemo } from 'react';
import { Redirect, Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';

import { log } from '../../../services/utils';

import { useAuthState } from '../../../contexts/AuthContext';
import { useUIAction } from '../../../contexts/UIContext';

import Contacts from './Contacts';
// import Funding from './Funding';
import Programs from './Programs';
import Events from './Events';

const Operations = () => {
	const { path: currentPath } = useRouteMatch();
	const { state: navigationState } = useLocation();

	const { user: { permissions } } = useAuthState();
	const { setSidebarMenu } = useUIAction();

	useEffect( () => {
		if ( navigationState
			? !navigationState.noSidebar
			: true
		) {
			setSidebarMenu( 'operations' );
		}
	}, [ navigationState, setSidebarMenu ] );

	const paths = useMemo( () => {
		const pathsArr = [];

		if ( permissions.listContacts.isAvailable ) {
			pathsArr.push( { path: `${ currentPath }/contacts`, component: Contacts } );
		}

		if ( permissions.listPrograms.isAvailable ) {
			pathsArr.push( { path: `${ currentPath }/programs`, component: Programs } );
		}

		if ( permissions.listCalendarEvents.isAvailable ) {
			pathsArr.push( { path: `${ currentPath }/calendar`, component: Events } );
		}

		return pathsArr;
	}, [ currentPath, permissions ] );

	const mapPaths = useCallback( () => paths.map( path => <Route key={ path.path } { ...path } /> ), [ paths ] );

	return (
		<Switch>
			{ log( 'operations' ) }
			{ mapPaths() }
			<Redirect from="*" to={ paths[ 0 ].path } />
		</Switch>
	);
};

export default memo( Operations );
